import * as ReactDOM from "react-dom";
import * as React from "react";
import { ApiErrorComponent } from "../lib/react/ApiErrorComponent";
import { FormAsyncReactComponent } from "../lib/react/FormAsyncReactComponent";
import { IErrorDetails } from "../lib/ErrorUtil";
import { AzureMediaPlayer } from "../ivAmp/AzureMediaPlayer";
import { EmbedResizeMode } from "../ivAmp/EmbedResizeMode";
import { IAzureMediaPlayerOptions } from "../ivAmp/IAzureMediaPlayerOptions";

export interface IIvAmpTextComponentProps { }
interface IIvAmpTestComponentState {
    url?: string;
    showPlayer?: boolean;
    error?: IErrorDetails|null;
    width: number;
    height: number;
    debugProgress: boolean;
    lang?: string;
    autoplay: boolean;
    controls: boolean;
    disableTextTracks: boolean;
    activeTextTrackLanguage?: string;
    debug: boolean;
    startAt?: number;
    initPaused?: boolean;
    disableFullscreen?: boolean;
    muted?: boolean;
    loop?: boolean;
    disableLoaderIcon?: boolean;
    scriptState: string;
    resizeMode: string;
    playerContainerWidth?: number;
    playerContainerHeight?: number;
    initBackground?: string;
    displayDuringInit?: boolean;
}

export class IvAmpTestComponent extends FormAsyncReactComponent<IIvAmpTextComponentProps, IIvAmpTestComponentState> {

    static readonly videoId: string = "someuniqueidforthepage";
    static readonly localStorageKey: string = "IvAmpTestComponent";
    videoInitDone: boolean = false;
    player: any;
    playerHtml?: string|null;
    oldSize: string;
    constructor(props) {
        super(props);
        this.state = IvAmpTestComponent.loadStateFromLocal();
        window.setInterval(() => { this.updateScriptStateAsync() }, 500);
    }
    saveStateToLocal() {
        try {
            var saveState = { ...this.state };
            //remove elements not included in save
            delete saveState.error;
            delete saveState.showPlayer;
            var data = JSON.stringify(saveState);
            window.localStorage.setItem(IvAmpTestComponent.localStorageKey, data);
        } catch (e) {
            console.log("Failed to save state to local storage. " + e);
        }
    }
    static clearStateFromLocal() {
        try {
            window.localStorage.removeItem(IvAmpTestComponent.localStorageKey);
        } catch (e) {
            console.log("Failed to clear local state" + e);
        }
    }
    static loadStateFromLocal(): IIvAmpTestComponentState {
        var defaultOverrideState: IIvAmpTestComponentState = {
            debug: true,
            showPlayer: false,
            error: undefined,
            width: 640,
            height: 360,
            debugProgress: false,
            autoplay: true,
            controls: true,
            disableTextTracks: false,
            loop: false,
            disableLoaderIcon: true,
            scriptState: "",
            resizeMode: EmbedResizeMode.Default.toString(),
            initBackground: "",
            displayDuringInit: false
        };
        var loadedData = {};
        var loadedDataString = window.localStorage.getItem(IvAmpTestComponent.localStorageKey);
        if (loadedDataString) {
            try {
                loadedData = JSON.parse(loadedDataString);
            } catch (e) {
                console.log("Failed to parse local storage data " + e);
                IvAmpTestComponent.clearStateFromLocal();
            }
        }
        return Object.assign({}, loadedData, defaultOverrideState);
    }
    componentDidUpdate() {
        if (this.state.showPlayer && !this.videoInitDone) {
            this.videoInitDone = true;
            try {
                //await AzureMediaPlayer.setupAsync(IvAmpTestComponent.videoId, { debug: true });
                //call script that is injected on page
                var options: IAzureMediaPlayerOptions = {
                    debug: this.state.debug,
                    debugProgress: this.state.debugProgress,
                    disableTextTracks: this.state.disableTextTracks,
                    activeTextTrackLanguage: this.state.activeTextTrackLanguage,
                    startAt: this.state.startAt,
                    initPaused: this.state.initPaused,
                    disableFullscreen: this.state.disableFullscreen,
                    muted: this.state.muted,
                    loop: this.state.loop,
                    disableLoaderIcon: this.state.disableLoaderIcon,
                    embedResizeMode: parseInt(this.state.resizeMode),
                    initBackground: this.state.initBackground,
                    displayDuringInit: this.state.displayDuringInit
                };
                this.player = new global.window.ImageVault.AzureMediaPlayer(IvAmpTestComponent.videoId, options);
                this.player.initAsync()
                    .then(() => { console.log("player init completed") })
                    .catch((e) => { console.log("Player init aborted " + e); });
                // this.player = await window.ImageVault.AzureMediaPlayer.setupAsync(IvAmpTestComponent.videoId, options);
                console.log("player setup completed");
            } catch (e) {
                this.setStateAsync({ error: e });
            }
        }
        //update player resize if player container size changes
        if (this.player && this.state.showPlayer && this.videoInitDone) {
            var newSize = this.state.playerContainerWidth + "x" + this.state.playerContainerHeight;
            if (this.oldSize != newSize) {
                this.player.handleResize();
                this.oldSize = newSize;
            }
        }
    }
    async updateScriptStateAsync() {
        let keys = Object.keys(window.ImageVault.AzureMediaPlayer.players);
        let ss = "#players: " + keys.length + ";";
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            var player: AzureMediaPlayer = window.ImageVault.AzureMediaPlayer.players[k];
            var playerData = "null";
            if (player && player.player) {
                playerData = "currentTime:" + player.player.currentTime();
            }
            ss += "[" + k + "]={" + playerData + "};";
        }
        await this.setStateAsync({ scriptState: ss });
    }
    async openPlayerAsync() {
        if (this.player)
            this.player.dispose();
        this.player = null;
        await this.setStateAsync({ showPlayer: false, error: null });
        this.saveStateToLocal();
        document.documentElement.lang = this.state.lang || "";
        this.playerHtml = null;
        this.videoInitDone = false;
        // await this.delay(20);
        await this.setStateAsync({ error: null, showPlayer: true });
    }
    renderPlayer(): JSX.Element|null {
        // if (this.state.error) return null;
        if (!this.state.showPlayer) return null;
        if (!this.playerHtml) {
            this.playerHtml = `<video class="azuremediaplayer amp-default-skin" id="${IvAmpTestComponent.videoId}" data-ivmdurl="${this.state.url}" width="${this.state.width}" height="${this.state.height}" ${this.state.controls ? "controls" : ""} ${this.state.autoplay ? "autoplay" : ""} preload="metadata"><p>To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video</p></video>`;
        }
        //since video tag is removed by player.dispose() we need to avoid react to 
        //manage the video tag. We just write it out as default
        var player = { __html: this.playerHtml };
        //div simulates an iframe
        var style: React.CSSProperties = {
            overflow: "hidden",
            border: "green solid 2px",
            boxSizing: "content-box",
            background: "aliceblue"
        };
        let w = "";
        if (this.state.playerContainerWidth) {
            style.width = this.state.playerContainerWidth + "px";
        }
        if (this.state.playerContainerHeight) {
            style.height = this.state.playerContainerHeight + "px";
        }
        return <div dangerouslySetInnerHTML={player} style={style}></div>

        // return <video className="azuremediaplayer amp-default-skin" id={this.getVideoId()} data-ivmdurl={this.state.url}
        //     width={this.state.width} height={this.state.height} controls autoPlay preload="metadata">
        //     <p>To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video</p>
        // </video>
    }
    renderError(): JSX.Element|null {
        if (!this.state.error) return null;
        return <ApiErrorComponent error={this.state.error} />
    }
    render() {
        return <div className="container">
            <div className="row top20">
                <div className="col-md-4">
                    {this.renderError()}
                    <div className="row">
                        <div className="col-xs-12">
                            {this.renderTextBox('url', 'Url')}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            {this.renderTextBox('width', 'Width', 'number')}
                        </div>
                        <div className="col-xs-6">
                            {this.renderTextBox('height', 'Height', 'number')}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            {this.renderTextBox('activeTextTrackLanguage', 'Active text lang.')}
                        </div>
                        <div className="col-xs-6">
                            {this.renderSelect('lang', 'UI lang.', [{ title: "Default", value: "" }, { title: "Svenska", value: "sv" }, { title: "Norsk", value: "no" }, { title: "Deutch", value: "de" }, { title: "English", value: "en" }])}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            {this.renderTextBox('startAt', 'Start at')}
                        </div>
                        <div className="col-xs-6">
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            {this.renderTextBox('playerContainerWidth', 'Player container Width', 'number')}
                        </div>
                        <div className="col-xs-6">
                            {this.renderTextBox('playerContainerHeight', 'Player container Height', 'number')}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            {this.renderSelect('resizeMode', 'Player resize mode', [
                                { title: "Default", value: EmbedResizeMode.Default.toString() },
                                { title: "Scale to Fit", value: EmbedResizeMode.ScaleToFit.toString() },
                                { title: "Scale to Fill", value: EmbedResizeMode.ScaleToFill.toString() },
                            ])}
                        </div>
                        <div className="col-xs-6">
                            {this.renderTextBox('initBackground', 'Init background CSS style')}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            {this.renderCheckbox('autoplay', 'Autoplay')}
                            {this.renderCheckbox('loop', 'Loop')}
                            {this.renderCheckbox('controls', 'Controls')}
                            {this.renderCheckbox('disableTextTracks', 'Disable text tracks')}
                            {this.renderCheckbox('disableFullscreen', 'Disable fullscreen')}
                            {this.renderCheckbox('displayDuringInit', 'Display during init')}
                        </div>
                        <div className="col-xs-6">
                            {this.renderCheckbox('muted', 'Muted')}
                            {this.renderCheckbox('initPaused', 'Init paused')}
                            {this.renderCheckbox('debug', 'Console output (debug)')}
                            {this.renderCheckbox('disableLoaderIcon', 'Disable loader icon')}
                            {this.renderCheckbox('debugProgress', 'Debug progress')}
                        </div>
                    </div>
                    <div>{this.state.scriptState}</div>
                    <button className="btn btn-primary" onClick={async () => { await this.openPlayerAsync(); }}>Open player</button>
                </div>
                <div className="col-md-8">
                    {this.renderPlayer()}
                </div>
            </div>
        </div>;
    }
}
//export to global namespace
((window as any).ImageVault = (window as any).ImageVault || {}).IvAmpTestPage = {
    init: (element: Element) => {

        ReactDOM.render(
            <IvAmpTestComponent />
            , element);
    }
};